import { createApp } from 'vue'
import router from './router/index'
import store from './store'
import common from '@/plugins/common'
import App from './App.vue'

import '@/assets/css/reset.css'
import '@/assets/css/style.css'
import '@/assets/css/style_pre.css'
import '@/assets/css/fontAwsome.css'

import mitt from 'mitt'
import {createI18n} from "vue-i18n";
import i18nMessage from "@/data/i18n.json";

const i18n = createI18n({
  // something vue-i18n options here ...
  legacy: false, // you must set `false`, to use Composition API
  locale: process.env.VUE_APP_I18N_LOCALE || 'kr', // set locale
  fallbackLocale: 'kr', // set fallback locale
  globalInjection: true,
  messages: i18nMessage.messages // set locale messages
})


const app = createApp(App)

const emitter = mitt()

app.config.globalProperties.emitter = emitter


app.use(store).mixin(common).use(router).use(i18n)

app.mount('body')
